import { locale } from './index.js';
import uz from './office-uz.js';
import uzCyrl from './office-uz-cyrl.js';

/* Словарь конторских экранов.

   ПОЧЕМУ КЛЮЧ — САМА РУССКАЯ ФРАЗА

   В цехе ключи смысловые: op.start, melt.close. Там полторы сотни надписей,
   каждая продумана, у половины подстановки, и имя ключа помогает их держать.

   В конторе надписей больше тысячи — заголовки колонок, подписи полей,
   кнопки диалогов. Придумать тысячу имён и не перепутать их нельзя,
   а цена ошибки в имени выше цены самой надписи: t('orders.colDue') вместо
   t('orders.colDone') даёт не сломанный экран, а тихо неверный.

   Поэтому ключ здесь — русский текст. Из этого следует главное свойство:
   ПРОПУЩЕННАЯ ФРАЗА ОСТАЁТСЯ РУССКОЙ, то есть ровно такой, какой она была
   до перевода. Недоперевод конторы не ломает контору.

   ОДИНАКОВЫЕ СЛОВА В РАЗНЫХ СМЫСЛАХ

   Плоский словарь не различает «Вид» как «тип» и «Вид» как «представление».
   Там, где это встретилось, ключ уточнён двоеточием: to('Вид: тип').
   Слева от двоеточия — то, что видит человек, справа — пометка для перевода;
   она на экран не попадает. */

const СЛОВАРИ = { uz, 'uz-Cyrl': uzCyrl };

/* Пометка смысла отбрасывается: to('Вид: тип') на русском даёт «Вид». */
const без = (ф) => (ф.includes(': ') && /: [а-яё ]+$/.test(ф) ? ф.slice(0, ф.indexOf(': ')) : ф);

export function to(фраза, params) {
  const словарь = СЛОВАРИ[locale.value];
  let s = (словарь && словарь[фраза]) || без(фраза);
  if (params) s = String(s).replace(/\{(\w+)\}/g, (_, k) => (params[k] ?? `{${k}}`));
  return s;
}

/* Реактивная обёртка — как useI18n для цеха: без чтения locale.value
   computed не пересчитается при смене языка. */
export const useOffice = () => ({ to: (ф, p) => { locale.value; return to(ф, p); } });

/* Сколько переведено — для проверки, а не для экрана. */
export const покрытие = (фразы) => {
  const итог = {};
  for (const [к, с] of Object.entries(СЛОВАРИ)) итог[к] = фразы.filter((ф) => с[ф]).length;
  return итог;
};
